<template>
  <div class="page-not-found">

    <div>
      <h1 class="page-not-found__title">
        <i class="fas fa-times fa-md mr-2"></i>
        Error 404
      </h1>
      <p class="page-not-found__message">Page not found</p>
      <v-btn
        outline
        color="teal lighten-2"
        class="page-not-found__link m-0"
        to="activities"
      >
        Back to home page
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageNotFound'
  }
</script>

<style scoped>
  .page-not-found {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #212121;
    color: #fff;
  }

  .page-not-found__title {
    position: relative;
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin-bottom: 10px;
  }

  .page-not-found__title::after {
    position: absolute;
    display: block;
    content: '';
    width: 45px;
    height: 1px;
    left: 0;
    bottom: 0;
    background-color: #fff;
  }


  .page-not-found__message {
    font-size: 18px;
  }

  .page-not-found__link {
    margin: 0;
  }

</style>
